module.exports = __webpack_public_path__ + "img/esg-1-icon-3.7e408d6d.svg";